import TextArea from 'antd/lib/input/TextArea';
import React from 'react';

interface Props {
  title?: string;
  rows: number;
}

const MechanicsRecordTextarea: React.FC<Props> = ({ title, rows }) => {
  return (
    <table style={{ marginBottom: 12 }}>
      {!!title && (
        <thead>
          <tr>
            <th>{title}</th>
          </tr>
        </thead>
      )}

      <tbody>
        <tr>
          <td>
            <TextArea rows={rows} />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default MechanicsRecordTextarea;
